/**
 * DxDy Site
 */

/* eslint-env browser */
"use strict";

import aos from "./vendor/aos";
import header from "./modules/header";
import carousel from "./blocks/_carousel";
import carouselImagery from "./blocks/_carousel-imagery";
import explore_our_work_carousel from "./blocks/_explore_our_work_carousel";
import our_impact_carousel from "./blocks/_our_impact_carousel";
import focus_area_carousel from "./blocks/_focus_area_carousel";
import process_accordion from "./blocks/_process_accordion";
import about from "./blocks/_about";
import flagship_programs_carousel from "./blocks/_flagship_programs_carousel";
import supporters_slider from "./blocks/_supporters_slider";
import upcomingConvenings from "./blocks/_upcoming-convenings";
import regionScroll from "./blocks/_region-scroll";
import floatingNav from "./blocks/_floating-nav";
import anchorScrollAnimation from "./modules/anchor-scroll-animation";
import numbersBlock from "./blocks/_numbers-block.js";
import viewHeightTextBlock from "./blocks/_view-height-text-block.js";
import mapIntro from "./blocks/_map-intro";
import useCases from "./blocks/_use-cases";
import ctaTextBlock from "./blocks/_cta-text-block";
import descriptionWithVideo from "./blocks/_description-with-video.js";
import contentRepository from "./blocks/_content-repository.js";
import foundationsExplorer from "./blocks/_foundations_explorer.js";
import spotlights from "./blocks/_spotlights.js";

(function ($) {
  aos.init();
  anchorScrollAnimation();
  header();
  carousel();
  carouselImagery();
  explore_our_work_carousel();
  our_impact_carousel();
  focus_area_carousel();
  process_accordion();
  about();
  flagship_programs_carousel();
  supporters_slider();
  upcomingConvenings();
  regionScroll();
  floatingNav();
  numbersBlock();
  viewHeightTextBlock();
  mapIntro();
  useCases();
  ctaTextBlock();
  descriptionWithVideo();
  contentRepository();
  foundationsExplorer();
  spotlights();
})(jQuery);
